export const EXPLORE_ROUTES = {
  states: '/explore/states',
  exams: '/explore/exams',
  subjects: '/explore/subjects',
  categories: '/explore/categories',
  topics: '/explore/topics',
  subtopics: '/explore/subtopics',
};
